import {lazy} from 'react';

export const ClinicAsync = lazy(() => import('./Clinic'));
